import React, { useEffect } from "react"

import { NotificationManager } from "react-notifications"
import { RouteComponentProps, useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import { path } from "~Tutor/TutorRoutes"
import { WithLoadingIndicator } from "~tailwindui/Basics"

import { MatchParams } from "src/types/MatchParams"

import ChimeCloudroomWrapper from "components/ChimeCloudroom/Wrapper"

const TutorCloudroom: React.FC<RouteComponentProps<MatchParams>> = ({
  match,
}) => {
  const sessionId = match.params.id
  const history = useHistory()

  const [result] = useQuery({ query, variables: { sessionId } })

  useEffect(() => {
    if (!result.data) return
    const { airtutorsSession } = result.data

    if (!airtutorsSession) {
      history.push(path("dashboard"))
      NotificationManager.error("You do not have access to this session")
    } else if (airtutorsSession.statusState === "canceled") {
      history.push(path("dashboard"))
      NotificationManager.error("This session has been canceled")
    } else if (!airtutorsSession.cloudroomActive) {
      history.push(path("dashboard"))
      NotificationManager.error(
        "This session's Cloud Room is not active at this time"
      )
    }
  }, [result, history])

  return (
    <WithLoadingIndicator result={result}>
      {({ data: { airtutorsSession } }) =>
        airtutorsSession && (
          <ChimeCloudroomWrapper sessionId={airtutorsSession.id} />
        )
      }
    </WithLoadingIndicator>
  )
}

const query = gql`
  query Cloudroom($sessionId: ID!) {
    airtutorsSession(id: $sessionId) {
      id
      statusState
      cloudroomActive
    }
  }
`

export default TutorCloudroom
